import { createFileRoute, Outlet } from "@tanstack/react-router";
export const Route = createFileRoute("/system/notifications/messages")({ component: Outlet });
